import * as documentsMutations from './documents-mutations'
import * as documentsQueries from './documents-queries'

export const documents = {
  mutations: documentsMutations,
  queries: documentsQueries
} as const
